import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Image, Modal, Row } from 'react-bootstrap'
export default function LandingPage2() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  useEffect(()=>{
    //storeAppDownloads
    uploadAppDownloadData(0)
  },[])
  const uploadAppDownloadData = async (btn_pressed) =>{
    const data = {
      page_name:'landingpage2',
      app_version:'1.2',
      is_download_btn_clicked:btn_pressed
    }
    await axios.post(`${process.env.REACT_APP_API_URL}/storeAppDownloads`,data)
    .then((response) =>{
      console.log(response);
    })
  }
  return (
    <>
      <Row  justify="center" style={{background:"#fff",height:"100%"}}>
        <Col span={4}>
          {/* <LandingPageHeader /> */}
          <Container style={{background:"#fff",height:"100%" }}>
            <Image 
              src={`${process.env.PUBLIC_URL}/landing_page_image/landing_page2_top.png`}
              style={{ width: "100%" }}
            />
            <a onClick={()=>{uploadAppDownloadData(1);handleShow()}} download={true} href={`${process.env.PUBLIC_URL}/apks/app-releasev1_2.apk`}>
            <Image
              src={`${process.env.PUBLIC_URL}/landing_page_image/landing_page2_botton.png`}
              style={{ width: "100%" }}
            />
            </a>
            <Image 
              src={`${process.env.PUBLIC_URL}/landing_page_image/landing_page2_bottom.png`}
              style={{ width: "100%" }}
            />
          </Container>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
               <div onClick={handleClose} style={{textAlign:'right'}}>X</div>
             </Modal.Header>
             <Modal.Body>
               <Image
                 src={`${process.env.PUBLIC_URL}/images/download _warning.jpg`}
                 style={{ width: "100%" }}
               />
        </Modal.Body>
      </Modal>
    </>
  )
}
